import React, {useEffect, useState} from 'react';
import {Trans} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import accountDao from '../../../../../dao/accountDao';
import {loadAuth} from '../../../../../components/auth/reducers';
import smbUtils from '../../../../../utils/smbUtils';
import {toast} from 'react-toastify';
import FormattedDate from '../../../../../components/product/FormattedDate';

export default function TechnicalSupport() {
  const {customer} = useSelector(state => state.components.auth.accountSummary);
  const serviceName = smbUtils.getFunctionTypeI18n(customer.functionType);
  const dispatch = useDispatch();
  const [enableTechnicalSupport, setEnableTechnicalSupport] = useState(false);
  const [checked, setChecked] = useState(false);
  const [modifiedTime, setModifiedTime] = useState(null);

  const request = () => {
    accountDao
      .updateTechnicalSupportStatus()
      .then(r => {
        dispatch(loadAuth());
        toast.success(
          <Trans i18nKey="c.f.simple.button.group.success">success</Trans>
        );
      })
      .catch(() => {
        toast.error(
          <Trans i18nKey="c.f.simple.button.group.failed">failed</Trans>
        );
      });
  };

  useEffect(() => {
    accountDao.queryTechnicalSupport().then(r => {
      if (r != null) {
        setEnableTechnicalSupport(true);
        setChecked(true);
        setModifiedTime(r.lastModified);
      }
    });
  }, []);
  return (
    <div className="d-flex justify-content-center align-items-center">
      {enableTechnicalSupport ? (
        <div className="d-block">
          <div>
            <Trans i18nKey="p.g.a.updateaccount.technical.support.in.progress">
              Your technical support is in progress.
            </Trans>
          </div>
          <div className="kt-margin-t-20">
            <Trans i18nKey="p.g.a.updateaccount.technical.support.request.time">
              Request Time:
            </Trans>{' '}
            <FormattedDate time={modifiedTime} />
          </div>
        </div>
      ) : (
        <label className="kt-checkbox kt-checkbox--brand">
          <input
            type="checkbox"
            checked={checked}
            onChange={e => setChecked(e.target.checked)}
          />
          <Trans i18nKey="p.g.a.updateaccount.technical.support.desc.agree">
            By checking this box, I understand and agree to authorize the
            Technical Support team access permissions for my {{serviceName}}{' '}
            service.
          </Trans>
          <span />
        </label>
      )}
      <div className="text-right" style={{flexGrow: 1}}>
        <button
          className="btn btn-primary"
          disabled={!checked}
          type="button"
          onClick={() => {
            request();
          }}
        >
          {enableTechnicalSupport ? (
            <Trans i18nKey="p.g.t.member.technical.support.remove">
              Remove Technical Support Permissions
            </Trans>
          ) : (
            <Trans i18nKey="p.g.a.updateaccount.technical.enable">
              Enable Technical Support
            </Trans>
          )}
        </button>
      </div>
    </div>
  );
}
